import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages} from 'react-intl';

import {FilterSubmitButton} from './FilterSubmitButton';
import styles from './RemoveFilterButton.less';

const I18N = defineMessages({
  TEXT: {
    id: 'filter.reset.text',
    defaultMessage: 'Reset filter',
    description: 'title text for remove filter button',
  },
  TITLE: {
    id: 'filter.reset.title',
    defaultMessage: 'Reset filter to default values.',
    description: 'title text for remove filter button',
  },
});

class RemoveFilterButton extends React.PureComponent {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleClick() {
    const {onClick} = this.props;
    onClick();
  }

  handleKeyDown(event) {
    const {onClick} = this.props;
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation();
      onClick();
    }
    return true;
  }

  render() {
    return (
      <span className={styles.dlRemoveFilterButton}>
        <FilterSubmitButton
          className={styles.dlRemoveFilterButtonButton}
          buttonText={I18N.TEXT.id}
          titleText={I18N.TITLE.id}
          onClick={this.handleClick}
          isDisabled={false}
        />
      </span>
    );
  }
}

RemoveFilterButton.displayName = 'RemoveFilterButton';

RemoveFilterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default RemoveFilterButton;
